import { FC, useMemo } from "react";

import { useReportsContext } from "@ryde/redux";
import { useIsMobile } from "@ryde/shared";

import { HeaderBottomLeftControls } from "../../bottom-line";
import { EditGridColumnButton, PanelTopRightStatItem } from "../../elements";
import { PanelStatStyled, TableRowsCountIcon } from "../panel-top.stat.styled";
import { ReportNavigationToggleButton } from "./report-navigation-toggle.button";

export const PanelTopStatReports: FC = () => {
  const { isMobile } = useIsMobile();
  const { reportRows } = useReportsContext();

  const rowsCount = useMemo(() => {
    if (!reportRows) {
      return undefined;
    }

    return reportRows.length;
  }, [reportRows]);
  return (
    <PanelStatStyled>
      {Boolean(isMobile) && (
        <span className="container_start">
          <ReportNavigationToggleButton />
        </span>
      )}
      <PanelTopRightStatItem
        e2eId="stat-rows-count"
        selected={rowsCount}
        hideTotal={true}
        label={<TableRowsCountIcon />}
      />

      {Boolean(isMobile) && <HeaderBottomLeftControls />}
      {Boolean(isMobile) && (
        <div className="stat_panel_end">
          <EditGridColumnButton />
        </div>
      )}
    </PanelStatStyled>
  );
};
